export default {
  connecting: {
    displayText: "Connecting",
    color: 'yellow'
  },
  connected: {
    displayText: "Connected",
    color: 'green'
  },
  disconnecting: {
    displayText: "Disconnecting",
    color: 'yellow'
  },
  disconnected: {
    displayText: "Disconnected",
    color: 'red'
  }
}
